export default __webpack_public_path__ + "static/media/04_divprase_info-min.968d4e9c.jpg";